import React from "react";
import { ClipLoader } from "react-spinners";
import PretendardText from "../atoms/text/pretendardText";

function Loading({ title }) {
  return (
    <div class="contentWrap">
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <ClipLoader color="#fff" height={15} width={5} radius={2} margin={2} />
        {title && (
          <PretendardText style={{ color: "#fff" }}>{title}</PretendardText>
        )}
      </div>
    </div>
  );
}

export default Loading;
